import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {Outsourced} from "../Outsourced";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {OutsourcedGameData} from "../server/OutsourcedData";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {OutsourcedGameAssets} from "../OutsourcedGameAssets";
import {RestoreUtils} from "../utils/RestoreUtils";
import GC_MAX_CHECK_COUNT = PIXI.settings.GC_MAX_CHECK_COUNT;

/**
 * Created by jonas on 2023-11-01.
 */

export class OutsourcedPromoPanelConfig implements PromoPanelGameConfiguration{

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Outsourced",
            hasActionSpin: true,
            disabledFeatureBets: ["CRASH_GAME"],
            //This is for automatically picking no always.
            graphics: {
                backgroundTextureName: "resources/images/Intro_BG.jpg"
            },
            getParsedData: (response: OutsourcedGameData, bet: number, prevResponse: OutsourcedGameData):ASWinData => {
                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpins(response),
                    totalSpinWinnings: this.getTotalWin(response, prevResponse),
                    isBigWin: this.isBigWin(response, prevResponse),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response, prevResponse),
                    isRoundComplete: this.isRoundComplete(response), //response.nextMode == GameMode.NORMAL,
                    isBonusEnd: this.isBonudEnd(response),
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    private getTotalWin(response: OutsourcedGameData, prevResponse:OutsourcedGameData):number {
        return response.mode == "UPGRADE_BET"
               ? prevResponse != undefined
                 ? prevResponse.totalSpinWinnings
                 : response.accumulatedRoundWin
               : response.totalSpinWinnings;
    }

    private isFreespinsMode(response:OutsourcedGameData):boolean {
        return response.mode == GameMode.FREESPIN;
    }

    private isFreeSpins(response:any){
        return (response.mode == GameMode.NORMAL || response.mode == "NORMAL_RESPIN") && (response.nextMode == GameMode.FREESPIN);
    }

    private getWinSize(response:OutsourcedGameData) {
        return response.thisSpinWinnings;
    }

    private getFeatureName(response: OutsourcedGameData, prevResponse: OutsourcedGameData): string {
        const relevantResponse = response.mode == "UPGRADE_BET" ? prevResponse : response;

        if (relevantResponse == undefined || relevantResponse.mode == "RESPIN")
            return "NORMAL";

        if (relevantResponse.mode == GameMode.FREESPIN || relevantResponse.nextMode == GameMode.FREESPIN ||
            relevantResponse.mode == "FREESPIN_RESPIN" || relevantResponse.nextMode == "FREESPIN_RESPIN"){
            return relevantResponse.scatterCount == 4 ? "SWEATIERSHOP SPINS" : "SWEATSHOP SPINS";
        }

        // meaning we got the option to play slash game but chose not too, only way to play the slash game in game
        // during action spins is to win max win in freespins meaning we can just check the scatter count to determine
        // the correct mode
        if (relevantResponse.mode == "CRASH_GAME")
            return relevantResponse.scatterCount == 4 ? "SWEATIERSHOP SPINS" : "SWEATSHOP SPINS";

        // if we actually chose to play the slash game then we will end on this mode instead, in which case we actually
        // set the mode to be slash game
        if (relevantResponse.mode == "CRASH_GAME_HANDSHAKE")
            return "SLASH GAME"

        return relevantResponse.mode;
    }

    private isBonudEnd(response: OutsourcedGameData):boolean {
        return response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL;
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN)
            Outsourced.soundPlayer.playSound("asWin");
        else if (trigger == ActionSpinSound.BIG_WIN)
            Outsourced.soundPlayer.playSound("asBigWin");
    }

    private isBigWin(response:OutsourcedGameData, prevResponse:OutsourcedGameData): boolean {
        const win = this.getTotalWin(response, prevResponse);
        const winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        const expensiveWinRatio = Helper.ceilToDecimals((win / Outsourced.getBetPrice()), 2);

        const smallThreshold =
            response.wasFeatureBuy || (Outsourced.getBetPrice() / response.playedBetValue) > 15;

        return smallThreshold ? expensiveWinRatio >= 1 : winRatio >= 15;
    }

    private isRoundComplete(response: OutsourcedGameData): boolean {
        return  ([GameMode.FREESPIN,GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    public onPlayBonusInGame(data: any) {
        Outsourced.model.onGame(data);
        RestoreUtils.restorePlayBonusInGame();
        setTimeout(() => {
            Outsourced.gameFlowController.start();
        }, 300);
    }
}